module.exports = __webpack_public_path__ + "static/media/actions-background-icon.3825105e.png";